export function applySignDocumentSelection(selected, item, checked) {
  const next = { ...selected };
  if (checked) {
    next[item.id] = item;
  } else {
    delete next[item.id];
  }
  return next;
}

export function applySignDocumentStatus(statusMap, signDocumentId, status) {
  return {
    ...statusMap,
    [signDocumentId]: status,
  };
}

export function buildFirmasDocumentosWhere(scope, statusId, signTypePhysic, signTypeNotPhysic) {
  const where = {
    status: statusId,
  };

  if (!scope) {
    return where;
  }

  const scopesFiltersMap = {
    not_transference: {
      extern_source: 'not_transference',
    },
    transference: {
      extern_source: 'transference',
      process_type: signTypeNotPhysic,
    },
    transference_physic: {
      process_type: signTypePhysic,
      extern_source: 'transference',
    },
  };

  return {
    ...where,
    ...(scopesFiltersMap[scope] || {}),
  };
}
